<script>
  import moment from 'moment';
  import {DateFormat} from '../../plugins/date-filter';

  export default {
    data() {
      return {
        dateOffset: 0,
        prevTimeout: {},
        nextTimeout: {},
        displayDate: moment(this.current),
      };
    },
    computed: {
      current() {
        return this.$route.params.date ? `${this.$route.params.date}-01` : this.displayDate.format(DateFormat.Canonical);
      },
      from() {
        return moment(this.current)
          .startOf('month')
          .subtract(6, 'days')
          .format(DateFormat.Canonical);
      },
      to() {
        return moment(this.current)
          .endOf('month')
          .add(6, 'days')
          .format(DateFormat.Canonical);
      }
    },
    methods: {
      goToDay(date) {
        this.$router.push({name: 'calendar-day', params: {date}});
      },
      prev() {
        clearTimeout(this.prevTimeout);
        clearTimeout(this.nextTimeout);

        this.dateOffset -= 1;
        this.displayDate = moment(this.current).add(this.dateOffset, 'months');
        this.prevTimeout = setTimeout(() => this.routeToNewDate(this.displayDate), 500);
      },
      next() {
        clearTimeout(this.prevTimeout);
        clearTimeout(this.nextTimeout);

        this.dateOffset += 1;
        this.displayDate = moment(this.current).add(this.dateOffset, 'months');
        this.nextTimeout = setTimeout(() => this.routeToNewDate(this.displayDate), 500);
      },
      routeToNewDate(val) {
        this.dateOffset = 0;
        this.displayDate = moment(val);
        this.$router.push({
          name: 'calendar-month',
          params: {
            date: val.format('YYYY-MM')
          }
        });
      },
      isInMonth(date) {
        return moment(date).isBetween(this.from, this.to, 'day', '[]');
      }
    }
  };
</script>
